import { Action, ActionNames } from '../actions';
import { OrderDetail } from '../store';
const reducer = (state: OrderDetail = null,  action: Action) => {
    if (action.type === ActionNames.OrderActions.fetchResult) {
        return action.order;
    }

    return state;
};

export default reducer;
